import React, { useMemo } from "react";
import { shallowEqual } from "react-redux";
import { ItemsMenuHorizontal } from "../../constants";
import { useChatsUIContext } from "../../context/ChatsContext";
import { useChatSelector } from "../../hooks/reduxHook";
import { useTabs } from "../../hooks/useTabs";
import { FramerTabHeader } from "../../lib/FramerTabHeader";
import { NavBarHeaderStyle } from "../../style";
import ChatInfo from "./chatInfo/ChatInfo";
import ChatUtils from "./chatUtils/ChatUtils";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";

const ChatHeader: React.FC = () => {
  const { t } = useAppTranslation("common");
  const localizedMenu = useMemo(
    () => ({
      ...ItemsMenuHorizontal,
      tabs: ItemsMenuHorizontal.tabs.map((tab) => ({
        ...tab,
        label:
          tab.id === "home"
            ? t("chat.tabs.all")
            : tab.id === "direct"
            ? t("chat.tabs.personal")
            : tab.id === "group"
            ? t("chat.tabs.group")
            : tab.label,
      })),
    }),
    [t]
  );
  const framer = useTabs(localizedMenu);

  const totalConversationList = useChatSelector(
    ({ chats }) => chats.totalConversationList,
    shallowEqual
  );

  const chatsContext = useChatsUIContext();
  const chatsUIProps = useMemo(() => {
    return {
      navigatePage: chatsContext?.navigatePage,
    };
  }, [chatsContext?.navigatePage]);

  return (
    <div
      className="d-flex flex-column justify-content-between"
      style={{
        borderBottom: "2px solid #353025",
      }}
    >
      <div className="d-flex align-items-center justify-content-between p-2">
        <ChatInfo />
        <ChatUtils />
      </div>
      {totalConversationList > 0 &&
        chatsUIProps?.navigatePage?.current === "home" && (
          <NavBarHeaderStyle>
            <FramerTabHeader {...framer.tabProps} />
          </NavBarHeaderStyle>
        )}
    </div>
  );
};
export default ChatHeader;
